
"use strict";

/*
 ## External Dependencies ##
 - jQuery ($)
 - Metrica.js
 */

var _ = require("underscore");
var moment = require("moment");
var cx = require("classnames");
var Reflux = require("reflux");
moment.locale("pt-br");

var textFormatter = require("app/util/formatter/text");
var getSlug = require("speakingurl");
var UserAvatar = require("app/shared/components/User/user-avatar");
var Upload = require("./upload.jsx");
var UploadProgress = require("./upload-progress.jsx");
var Schedule = require("./schedule");
var ActivityOwner = require("./activity-owner.jsx");
var EntitySuggestions = require("app/shared/components/EntitySuggestions/entity-suggestions");
var MetricType = require("../Metric/metric-type.jsx");
var MetricsContainer = require("../Metric/metrics-container.jsx");
var ActivityTypesLoading = require("app/screens/Activity/components/ActivityInput/activity-types-loading");

var ButtonGroup = require("app/shared/components/ButtonGroup/button-group");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");

var ActivitiesListingActions = require("app/screens/Activity/actions/activities-listing-actions");
var ScheduleActions = require("app/screens/Activity/actions/schedule-actions");
var ActivityInputActions = require("app/screens/Activity/actions/activity-input-actions");
var ActivityInputStore = require("app/screens/Activity/stores/activity-input-store");
var EntitySuggestionsActions = require("app/shared/actions/entity-suggestions-actions");
var EntitySuggestionsStore = require("app/shared/stores/entity-suggestions-store");
var SignalActions = require("app/shared/actions/signal-actions");

var MultiActionStore = require("app/util/flux/multi-action-store");

var ActivityInput = React.createClass({
  mixins: [Reflux.ListenerMixin, MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputStore: ActivityInputStore,
      activityInputActions: ActivityInputActions,
    };
  },
  getInitialState: function () {
    var initialState = this.activityInputStore.getInitialState();
    return initialState;
  },
  componentDidMount: function() {
    this.listenTo(this.activityInputStore, this.setState);
  },
  cancelEdition: function() {
    ActivitiesListingActions.cancelEdition(this.state.activityId);
  },
  render: function render() {
    return (
      <div className="activityInput">

        {(this.state.editing)?[
        <ActivityOwner dropbox={this.state.dropbox} createdBy={this.state.createdBy} key="1" />,
        <button type="button" onClick={this.cancelEdition} className="activityInput-close close" aria-label="Close" key="2"><span aria-hidden="true">&times;</span></button>
        ]:null}

        <ActivityInputTypes {...this.state} instanceKey={this.props.instanceKey}/>

        <ActivityInputText {...this.state} instanceKey={this.props.instanceKey}/>

        {(this.state.expandedActions)?[
          <ActivityInputDetails {...this.state} key="details" />,
          <ActivityInputMetricsContainer {...this.state} key="metrics" />,
          <ActivityInputActionsElem {...this.state} key="actions" />,
          <ActivityInputOptions {...this.state} key="options" />
        ]:null}

        <div className="u-clear"></div>

        <Schedule instanceKey={this.props.instanceKey} />

      </div>
    );
  }
});

var ActivityInputMetricsContainer = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions,
    };
  },
  render: function() {

    var metrics = [];

    if (this.props.metrics && this.props.metrics.length  > 0) {
      for (var key in this.props.metrics) {
        var metric = this.props.metrics[key];
        if (!metric.metric_type) {
          metric.removable = true;
          metric.onRemove = this.activityInputActions.removeMetric;
          metrics.push(metric);
        }
      }
    }

    return (
      <MetricsContainer className="activityInput-metrics" metrics={metrics} />
    );
  }
});

var ActivityInputDetails = React.createClass({
  render: function render() {
    return (
      <div className="activityInput-details">
        <div className="d-f jc-sb">
          <ActivityInputAssignment {...this.props} />
          <ActivityInputEntity {...this.props} />
        </div>
        <ActivityInputFiles {...this.props} />
        <div className="u-clear"></div>
      </div>
    );
  }
});

var ActivityInputAssignment = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      scheduleActions: ScheduleActions
    };
  },
  showSchedule: function (event) {
    event.preventDefault();
    this.scheduleActions.toggle(true, event.currentTarget);
  },
  render: function render() {
    var time = moment(this.props.dueDate).format("HH:mm:ss");
    var visualTime = moment(this.props.dueDate).format("HH:mm");
    var dueDate = moment(this.props.dueDate).format("DD/MM/YYYY");//14/02/2015 - dia inteiro;
    if (time!="23:59:59") {
      dueDate += " às "+visualTime;
    }

    var isPastDueDate = moment(this.props.dueDate).isBefore(moment(), "day");
    var dueLabel = (isPastDueDate && !this.props.editing) ? "Realizada em" : "Prazo";

    return (this.props.dueDate)?(
      <div className="activityInput-assignment">
        <div className="activityInput-due">
          {dueLabel}: <a className="activityInput-dueLink ml-5" onClick={this.showSchedule} href="javascript:void(0);">{dueDate}</a>
        </div>
        <div className="activityInput-verticalSeparator"></div>
        <ActivityInputOwners {...this.props} />
        <div className="u-clear"></div>
      </div>
    ):null;
  }
});

var ActivityInputOwners = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      scheduleActions: ScheduleActions
    };
  },
  showSchedule: function (event) {
    event.preventDefault();
    this.scheduleActions.toggle(true, event.currentTarget);
  },
  componentDidMount: function() {
    this.applyTooltip();
  },
  componentDidUpdate: function() {
    this.applyTooltip();
  },
  applyTooltip: function() {
    $(ReactDOM.findDOMNode(this)).find(".activityInput-owner")
    .tooltip({
      delay: {show:300, hide:0}
    })
    .tooltip("fixTitle");
  },
  render: function render() {
    var owners = [];
    var tooltipOwners = [];
    var maxVisibleOwners = 5;

    for (var key in this.props.owners) {
      var owner = this.props.owners[key];

      if (key<maxVisibleOwners) {
        owners.push(
          <UserAvatar className="activityInput-owner" name={owner.name} avatarURL={owner.avatarURL} key={key} />
        );
      }
      else {
        tooltipOwners.push(owner.name);
      }
    }

    return (owners.length>0)?(
      <div className="activityInput-owners d-f align-center">
        {owners}
        {(tooltipOwners.length>0)?<a className="activityInput-owner userAvatar activityInput-showMoreOwners bg-white fw-400" title={tooltipOwners.join(", ")} href="javascript:void(0);">+{tooltipOwners.length}</a>:null}
        <a className="activityInput-editOwners ml-10" onClick={this.showSchedule} href="javascript:void(0);">editar</a>
        <div className="u-clear"></div>
      </div>
    ):null;
  }
});

var ActivityInputOptions = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions,
      scheduleActions: ScheduleActions
    };
  },
  showSchedule: function (event) {
    event.preventDefault();
    this.scheduleActions.toggle(true, event.currentTarget);
  },
  cancelSchedule: function() {
    this.activityInputActions.setDueDateAndOwners(null, []);
  },
  render: function render() {

    var scheduleLink = (
      <a className="activityInput-setDue d-f mr-10" onClick={this.cancelSchedule} href="javascript:void(0);">
        <span className="custom-glyphicon icon-close"></span>
        Cancelar agendamento
      </a>
    );

    if(!this.props.dueDate) {
      scheduleLink = (
        <a className="activityInput-setDue d-f mr-10" onClick={this.showSchedule} href="javascript:void(0);">
          <span className="custom-glyphicon icon-calendar"></span>
          Definir um agendamento
        </a>
      );
    }

    return (
      <div className="activityInput-options fs-12 f-l ml-2 d-f">
        {(!this.props.isTask)?scheduleLink:null}
        <ActivityFileUploader {...this.props} />
      </div>
    );
  }
});

var ActivityInputEntity = React.createClass({
  render: function () {
    return (this.props.isTask)?(
      <div className="w-300">
        <EntitySuggestions instanceKey={this.props.instanceKey} />
      </div>
    ):null;
  }
});

var ActivityFileUploader = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions
    };
  },
  onFileSelected: function (file) {
    file.id = Math.floor(Math.random() * 1000000);
    this.activityInputActions.addFile(file);
  },
  render: function() {
    return (
      <Upload className="d-ib" onFileSelected={this.onFileSelected}>
        <a className="activityInput-attachFile" href="javascript:void(0);">
          <span className="custom-glyphicon icon-arrow-up"></span>
          Adicionar arquivos ou imagens
        </a>
      </Upload>
    );
  }
});

var ActivityInputText = React.createClass({
  mixins: [React.addons.LinkedStateMixin, MultiActionStore.mixin],
  setTextTimeout: null,
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions
    };
  },
  getInitialState: function() {
    return {
      text: this.props.text,
      open: this.props.expandedText
    };
  },
  componentDidMount: function() {
    if (this.state.open) {
      this.refs.text.focus();
    }

    var metricaBoxUI = new MetricaBoxUI({
      bindTo: this.refs.text,
      onMetricSelected: this.activityInputActions.setMetric,
      onReturnTargetLastValue: this.activityInputActions.setText
    });
  },
  onFocus: function() {
    // reuse previous inserted text that was canceled
    if (this.props.discardedText != null && !this.state.text) {
      this.activityInputActions.useDiscardedText(false);
    }
    this.activityInputActions.toggle(true, true);
  },
  componentWillReceiveProps: function(props) {
    var state = {
      text: props.text
    };
    state.open = props.expandedText || false;
    this.setState(state);
  },
  onChange: function(e) {
    var value = e.target.value;
    this.activityInputActions.setText(value);
  },
  onBlur: function() {
    if(
      (!this.refs.text.value||this.refs.text.value=="")
      &&!$(this.refs.text).parent().is(":hover")
      ) {
      this.activityInputActions.toggle(this.props.expandedActions, false);
    }
  },
  render: function render(){
    var classes = cx({
      "open": (this.state.open),
      "activityInput-text": true
    });
    return (
      <textarea className={classes} ref="text" onBlur={this.onBlur} onFocus={this.onFocus} value={this.state.text} onChange={this.onChange} placeholder="O que foi feito e qual o pr&oacute;ximo passo?"></textarea>
    );
  }
});

var ActivityInputTypes = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions
    };
  },
  componentDidMount: function() {
    this.activityInputActions.getActivityTypes();
  },
  render: function render() {
    var buttons = [];
    _.each(this.props.types, function(type, i) {
      buttons.push(<ActivityInputType instanceKey={this.props.instanceKey} {...type} expandedActions={this.props.expandedActions} expandedText={this.props.expandedText} key={type.id} />);
    }.bind(this));

    return (buttons.length>0)?(
      <ButtonGroup className='w-100 d-f'>
        {buttons}
      </ButtonGroup>) : <ActivityTypesLoading />;
  }
});

var ActivityInputType = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions
    };
  },
  select: function() {
    this.activityInputActions.selectType(this.props.id, !this.props.selected);
    this.activityInputActions.setText(this.props.name, true, !this.props.selected);
    this.activityInputActions.toggle(true, this.props.expandedText);
  },
  render: function render(){
    var metricType = (this.props.metric_type)?this.props.metric_type.name:null;
    var classNames = cx({
      "selected": this.props.selected,
      "flex-1": true,
      "d-f": true,
      "jc-sa": true
    });

    return (
      <Button type="filter" className={classNames} onClick={this.select}>
        <div>
          <Icon custom icon={MetricType.getIconClass(metricType)}></Icon>
          <span>{this.props.name}</span>
        </div>
      </Button>
    );
  }
});

var ActivityInputFiles = React.createClass({
  render: function render() {
    var files = [];
    _.each(this.props.files, function(file, i) {
      file = {
        id: file.id,
        extension: file.extension,
        name: getSlug(file.name, { custom: { ".": "." } }),
        progress: file.progress,
        uploadState: file.uploadState,
      };
      files.push(<ActivityInputFile instanceKey={this.props.instanceKey} key={file.id} {...file} />);
    }.bind(this));

    return (files.length>0)?(
      <div className="activityInput-files">
        {files}
      </div>
    ):null;
  }
});

var ActivityInputFile = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions
    };
  },
  remove: function() {
    this.activityInputActions.removeFile(this.props.id);
  },
  render: function render() {
    return (
      <div className="activityInput-file">
        <div className="activityInput-fileType tt-upper">{this.props.extension}</div>
        <div className="activityInput-fileName d-ib">{this.props.name}</div>
        <button type="button" onClick={this.remove} className="activityInput-deleteFile close"><span aria-hidden="true">&times;</span></button>
        <UploadProgress {...this.props}/>
      </div>
    );
  }
});


var ActivityInputActionsElem = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function() {
    return {
      activityInputActions: ActivityInputActions,
      entitySuggestionsActions: EntitySuggestionsActions,
      scheduleActions: ScheduleActions
    };
  },
  cancel: function() {
    this.activityInputActions.refresh();
    if (this.props.isTask) {
      this.entitySuggestionsActions.clearSelected();
      this.scheduleActions.clearSelected();
    }
  },
  cancelEdition: function() {
    ActivitiesListingActions.cancelEdition(this.props.activityId);
  },
  allFilesUploaded: function () {
    var allFilesUploaded = true;
    _.each(this.props.files, function(file, i) {
      allFilesUploaded = allFilesUploaded && file.uploadState == "completed";
    });
    return allFilesUploaded;
  },
  componentDidUpdate: function (prevProps) {
    // check if isReadyToSave changed from false to true
    if (!prevProps.isReadyToSave && this.props.isReadyToSave) {
      this.save(prevProps);
    }
  },
  prepareSave: function () {
    var errorMsg = null;

    if (!textFormatter.trim(this.props.text)) {
      errorMsg = "O texto da atividade é obrigatório.";
    }
    else if (!this.props.entity) {
      errorMsg = "Informe a empresa, pessoa ou negócio relacionado.";
    }

    if (errorMsg) {
      SignalActions.show({ message: errorMsg, type: "warning", hideTimeout: 5000 });
    } else {
      this.activityInputActions.saveButtonPressed();
    }
  },
  save: function(props) {

    var images = [];
    var documents = [];
    var metrics = props.metrics;

    _.each(props.types, function(type) {
      if (type.selected) {
        metrics.push({
          id: type.id,
          name: type.name,
          value: type.value || 1,
          isActivityType: true
        });
      }
    });

    _.each(props.files, function(file) {

      if (file.type.indexOf("image")!=-1) {
        images.push({
          id: file.id,
          file_name: getSlug(file.name, { custom: { ".": "." } }),
          temporary_key: file.tempKey
        });
      } else {
        documents.push({
          id: file.id,
          file_name: getSlug(file.name, { custom: { ".": "." } }),
          document_type: file.extension,
          temporary_key: file.tempKey
        });
      }
    });

    var activityDueDate = props.dueDate;

    if (props.dueDate) {
      activityDueDate = moment(props.dueDate).format("YYYY-MM-DD HH:mm:ss");
    }

    var activity = {
      text: textFormatter.trim(props.text),
      metrics: metrics,
      documents: documents,
      images: images,
      due_date: activityDueDate,
      timezone: props.timezone
    };

    var hasActivityTypeMetric = _.contains(_.pluck(metrics, "isActivityType"), true);

    if (!props.editing && hasActivityTypeMetric && (props.initialDueDate == null && activity.due_date === null)) {
      var currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
      activity.due_date = currentDate;
      activity.finished_date = currentDate;
    }

    if (activity.due_date != null) {
      var users = _.pluck(props.owners, "id");
      if (users && users.length > 0) {
        activity.assigned_users = users;
      } else {
        activity.assigned_users = [(window.loggedUserId).toString()];
      }
    }

    if (!props.editing && activity.due_date && moment(activity.due_date).isBefore(moment(), "day")) {
      activity.finished_date = activity.due_date;
    }

    if (props.editing) {
      activity.id = props.activityId;
    }

    if (props.entity.type == "organization") {
      activity.organization_id = props.entity.id;
    }
    else if (props.entity.type == "person") {
      activity.person_id = props.entity.id;
    }
    else if (props.entity.type == "deal") {
      activity.deal_id = props.entity.id;
    }

    if (props.editing) {
      this.activityInputActions.update(activity);
    } else {
      this.activityInputActions.save(activity, this.props.isTask);
    }
  },
  getSaveLabel: function () {
    if (this.props.saveButtonPressed && this.allFilesUploaded()) {
      return "Salvando";
    } else {
      return "Salvar";
    }
  },
  render: function render() {
    var disableSaveButton = (this.props.saveButtonPressed);
    var saveButtonTitle = (!this.props.text)?"O texto  da atividade é obrigatório":null;
    var onCancelClick = (this.props.editing)?this.cancelEdition:this.cancel;
    return (
      <div className="activityInput-actions f-r">
        <a className="activityInput-cancel mr-20" onClick={onCancelClick} href="javascript:void(0);">cancelar</a>
        <button ref="saveButton" className="btn btn-success"
            disabled={disableSaveButton} onClick={this.prepareSave}>{this.getSaveLabel()}</button>
      </div>
    );
  }
});

module.exports = ActivityInput;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/activity-input.jsx